import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';

/**
 * 受保護路由包裝器。未登入會被 redirect 到 /login，
 * 並把原本要去的位置存在 location.state.from，登入成功後跳回。
 *
 * 用法：
 *   <Route path="/account" element={
 *     <PrivateRoute><AccountPage /></PrivateRoute>
 *   } />
 *
 * 設計重點：
 *   - 等 AuthContext 完成 silent refresh（isInitializing=false）才判斷，
 *     避免「重新整理就被踢回登入頁」的閃爍 bug。
 */
function PrivateRoute({ children }) {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    // silent refresh 進行中，先顯示空白避免閃爍
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
